// Specializations data array
export const SPECIALIZATIONS_DATA = [
  { id: 'cd1b06ab-5f4b-4b9e-a0ea-61c8fa85084f', name: 'Allergy and immunology' },
  { id: '32166d1d-a160-46e1-948c-3b2a55ea2e08', name: 'Anesthesiology' },
  { id: '242ddd69-0f40-4f36-9f7f-d0f9058dfe9c', name: 'Cardiology' },
  { id: '7d1e99b0-f58f-465c-8d52-05ea8f6c5ca4', name: 'Dentistry' },
  { id: '3dfa4d5a-a808-4d47-8705-88161f048b0b', name: 'Dermatology' },
  { id: '23c539dc-ce2c-4874-8d1d-a6e03a68eb7c', name: 'Diagnostic radiology' },
  { id: 'a24f6eb1-99f3-4162-a8bf-88588c8bd1de', name: 'Emergency medicine' },
  { id: '0483b316-1ad4-4889-90bf-c05b6ced5aeb', name: 'Endocrinology' },
  { id: 'c84238fc-32cf-4604-9a72-11c58728eeec', name: 'Family medicine' },
  { id: '301acec1-2e78-4786-81a2-c4bf018815ef', name: 'Gastroenterology' },
  { id: 'aeaefc92-25b0-402f-be17-1979a8fab0c4', name: 'General' },
  { id: '95cfee84-c4de-4a64-bbc1-36e104c4e4a5', name: 'Geriatric medicine' },
  { id: 'ce20c39e-9f4f-4ce5-8e31-62bd689aaf40', name: 'Hematology' },
  { id: 'b66f2b6f-923a-4ac5-b8bf-0b7841300088', name: 'Internal medicine' },
  { id: '76d100f9-6f76-41b6-a4be-57b5fe97d349', name: 'Medical genetics' },
  { id: 'cafa1bdb-4033-41b5-90ab-67b21686aded', name: 'Nephrology' },
  { id: 'acc6ef87-0dd1-46fa-a1c0-2ba775b3375e', name: 'Neurology' },
  { id: 'a5206342-5a75-4096-a97e-043cf42591f8', name: 'Nuclear medicine' },
  { id: 'e89e6581-443d-421b-9681-96230447b7e5', name: 'Obstetrics and gynecology' },
  { id: 'c756358b-50df-4397-93a5-3902045e9c60', name: 'Oncology' },
  { id: 'c69241ae-6e80-4eab-9b25-34a01ee1a7b4', name: 'Ophthalmology' },
  { id: '30a8d862-a102-4313-9026-370912736a38', name: 'Otolaryngology' },
  { id: 'a2bd0e42-e86f-48f0-a049-f1f106058990', name: 'Pathology' },
  { id: 'e27b83ac-3335-449e-a421-bef8e2be8a13', name: 'Pediatrics' },
  { id: '75ea8bee-0753-4d0c-bb41-8677e205e299', name: 'Physical medicine and rehabilitation' },
  { id: 'dc4432f2-cec5-4d92-8776-960c139a9d25', name: 'Preventive medicine' },
  { id: '089a6f11-2b5b-4e6a-b9f9-3ef44eb6301c', name: 'Psychiatry' },
  { id: '588b2ee7-994d-47d2-9d5d-115ddead2348', name: 'Rheumatology' },
  { id: 'c53f690a-c267-4882-a5f8-c55ed85e3c3c', name: 'Surgery' },
  { id: '975999b7-3f99-43da-bcc3-2256554aaee1', name: 'Urology' },
];